import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageProgressKind, MessageProgressStep, MessageProgressTool } from '../../models/message-progress-step.model';
import { summarizeProgress } from '../../services/message-progress.helper';

const KIND_ICONS: Record<MessageProgressKind, string> = {
  data_query: 'assets/icons/search.svg',
  documentation: 'assets/icons/book.svg',
  context: 'assets/icons/settings.svg',
  other: 'assets/icons/circle-info.svg'
};

/**
 * The agent's progress on a turn (DATA-1629): its notes as short lines and one chip per lookup.
 * Expanded while the answer is still being worked out, collapsed to a one-line summary once it has
 * started, and openable again from there.
 *
 * Only `text` and `label` are ever rendered. Nothing here knows a query, a table or a tool name.
 */
@Component({
  selector: 'deo-message-progress',
  standalone: false,
  templateUrl: './deo-message-progress.component.html',
  styleUrl: './deo-message-progress.component.scss'
})
export class DeoMessageProgressComponent {
  @Input() steps: MessageProgressStep[] = [];

  @Input() collapsed = false;

  @Output() toggled$ = new EventEmitter<void>();

  get hasSteps(): boolean {
    return this.steps.length > 0;
  }

  get summary(): string {
    return summarizeProgress(this.steps);
  }

  toggle(): void {
    this.toggled$.emit();
  }

  iconFor(tool: MessageProgressTool): string {
    return KIND_ICONS[tool.kind];
  }

  stateLabel(tool: MessageProgressTool): string {
    if (tool.inProgress) {
      return 'in progress';
    }
    return tool.ok === false ? 'could not complete' : 'done';
  }

  protected trackByStep(index: number, step: MessageProgressStep): number {
    return step.step;
  }
}
